<template>
    <div v-if="isLoading" class="d-flex min-vh-100 justify-content-center flex-column">
        <Loader/>
    </div>
    <router-view v-else/>
</template>
<script>
    import {mapGetters} from 'vuex';

    import Loader from '@/components/global/Loader';
    import * as storeTypes from './vuex/root.store-types';

    export default {
        name: 'app',
        components: {Loader},
        computed: mapGetters({
            /** @type {boolean|*} */
            isLoading: storeTypes.GET_IS_LOADING,
        }),
    }
</script>
